export const cardCheckBoxZIndex = 1;
export const popoverOverlayZIndex = 99;
export const isLoadingModalZIndex = 999;
export const subscriptionPrompt = 9999;
export const notificationPaneZIndex = 99999;